export enum DATA_QA {
  ROOT = 'search-dropdown',
  INPUT = 'search-dropdown__input',
  INPUT_ICON = 'search-dropdown__input-icon',
  DROPDOWN = 'search-dropdown__dropdown',
  DIVIDER = 'search-dropdown__divider',
  STATIC_GROUP = 'search-dropdown__static-group',
  ITEM = 'search-dropdown__item',
  ITEM_ICON = 'search-dropdown__item-icon',
  GROUP = 'search-dropdown__group',
  NO_RESULTS_ICON = 'search-dropdown__no-results-icon',
  VALIDATION_MESSAGE = 'validation-message',
  RIGHT_ICON = 'search-dropdown__right-icon',
}

export enum SearchDropdownError {
  REQUIRED = 'REQUIRED',
  MIN_VALUE = 'MIN_VALUE',
  MAX_VALUE = 'MAX_VALUE',
}
